// extracted by mini-css-extract-plugin
module.exports = {"mainscreen":"Game_over_mainscreen__2D03S","link":"Game_over_link__2_FbY"};